// Must use function instead of class because that is what
// bluebird promise expects to catch
// See http://bluebirdjs.com/docs/api/catch.html for documentation
function DefunctVideoComponentError() {}
DefunctVideoComponentError.prototype = Object.create(Error.prototype);

export { DefunctVideoComponentError };
export default DefunctVideoComponentError;
